import React from "react";

import RecipeSlider from "../RecipeSlider/RecipeSlider";
import HomePageFilter from "../HomePageFilter/HomePageFilter";
import Card from "../Card/Card";

import RestaurantsName from "../RestronName/RestronName";
import HomeSlider from "../HomeSlider/HomeSlider";
import Street from "../Street/Street";
import Offer from "../Offer/Offer";


import Foodchain from "../Foodchain/Foodchain";

const Home = () => {
  return (
    <div>
     
      <br></br>
      <h1 className="tag" style={{ marginLeft: "90px", marginBottom: "20px" }}>
        ab ho craving ka scene ,ZikRme on your screen
      </h1>

      <HomeSlider />
      <h2 style={{ marginLeft: "70px", marginTop: "20px" }}>
        Choose Your Favourite
      </h2>
      <RecipeSlider />
      <br></br>
      <h2 style={{ marginLeft: "70px" }}>what would you like to choose</h2>
<br></br>
      <Card />
      <HomePageFilter />
      <br></br>
      <Foodchain/>
      <h2 style={{ marginLeft: "70px", marginTop: "40px" }}>Street food</h2>
      <br></br>
      <Street />
   
     
      <h1 style={{ marginLeft: "50px", marginTop: "30px" }}>
        Hot Deal, Fresh Taste!
      </h1>
      <Offer />
      <h2 style={{ marginLeft: "80px", marginTop: "50px" }}>
        Choose the Restaurant
      </h2>
      <RestaurantsName />
    
    </div>
  );
};

export default Home;
